import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone } from "lucide-react";

// Visible only during night hours: 21:00 -> 05:00
function isNightTime() {
  const h = new Date().getHours();
  return h >= 21 || h < 5;
}

export const SosButton = () => {
  const [visible, setVisible] = useState(isNightTime());

  useEffect(() => {
    const id = setInterval(() => setVisible(isNightTime()), 60 * 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="fixed mb-sos-el left-1/2 -translate-x-1/2 w-full max-w-[440px] px-5 flex justify-end pointer-events-none z-[60]"
      style={{ bottom: "calc(6rem + env(safe-area-inset-bottom))" }}
    >
      <AnimatePresence>
        {visible && (
          <motion.a
            href="tel:112"
            data-testid="sos-button"
            aria-label="SOS - chiama 112"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 320, damping: 20 }}
            className="pointer-events-auto relative flex flex-col items-center justify-center w-16 h-16 rounded-full bg-red-600 text-white font-display font-extrabold shadow-[0_8px_24px_rgba(220,38,38,0.55)] active:bg-red-700"
          >
            <span className="absolute inset-0 rounded-full bg-red-500 animate-ping opacity-60" />
            <Phone size={18} className="relative z-10" strokeWidth={2.6} />
            <span className="relative z-10 text-[11px] leading-none mt-0.5 tracking-wide">SOS</span>
          </motion.a>
        )}
      </AnimatePresence>
    </div>
  );
};
